import { Box } from '../../../imports/muiImport';

function MobileProductDetailImage({ image }) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        py: 0,
      }}
    >
      <Box
        sx={{
          width: {
            xs: '90%',
            sm: '70%',
            md: '50%',
          },
          maxWidth: {
            xs: '300px',
            sm: '400px',
            md: '500px',
          },
          height: {
            xs: '200px',
            sm: '250px',
            md: '300px',
          }, // explicit height instead of paddingTop
          borderRadius: 4,
          boxShadow: 5,
          overflow: 'hidden',
          backgroundColor: '#fff', // can change to 'transparent' if needed
          position: 'relative',
          border: '2px solid white',
        }}
      >
        <Box
          component="img"
          src={image}
          alt="Product Preview"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
    </Box>
  );
}

export default MobileProductDetailImage;
